import { ACTIVE_AUDIT_STATUSES } from "@/lib/audit-status";

export const DEFAULT_STALE_AUDIT_DAYS = 14;
export const MAX_STALE_AUDIT_DAYS = 365;

const DAY_MS = 24 * 60 * 60 * 1000;

interface StaleAuditInfo {
  /** True when an unfinished audit has had no activity for the configured number of days. */
  isStale: boolean;
  /** Whole days since the audit last changed. */
  idleDays: number;
}

/**
 * Activity is anything that bumps the audit's updated-at (notes, attachments,
 * checklist changes, status changes, reassignment). A completed audit never
 * needs attention.
 */
export function staleAuditInfo(
  audit: { status: string; updatedAt: Date },
  thresholdDays: number,
  now: Date = new Date(),
): StaleAuditInfo {
  const idleDays = Math.max(0, Math.floor((now.getTime() - audit.updatedAt.getTime()) / DAY_MS));
  const active = (ACTIVE_AUDIT_STATUSES as readonly string[]).includes(audit.status);
  return { isStale: active && idleDays >= thresholdDays, idleDays };
}
